import { RemoteGetSuspectedManipulationCount } from 'data/usecases';
import { GetSuspectedManipulationCountUseCaseInterface } from 'domain/usecases';
import { makeApiUrlSuspectedManipulationCount } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetSuspectedManipulationCount =
  (): GetSuspectedManipulationCountUseCaseInterface =>
    new RemoteGetSuspectedManipulationCount(
      makeApiUrlSuspectedManipulationCount(),
      makeAxiosHttpClient(),
    );
